import React from 'react';
import { Table } from '../../../components/table/Table';
import { getCurrentMonth, useFilter } from '@unthinkable/react-filters';
import { useAppStateContext } from '../../../providers/AppState';
import { GroupFilter, SearchFilter } from '../../../components/filter/Filters';
import { TabView } from '../../../components/tab';
import { randomColor } from '../../../utils/util';
import { useTheme } from '@unthinkable/react-theme';
import { IconButton } from '../../../components/button/IconButton';


const VoucherTdsTable = props => {
    const { filterParams, searchValue, params } = props;
    return (
        <Table
            {...props}
            api={'/vouchertdsreport'}
            addOnFilter={filterParams}
            params={params}
            eventSourceId="GST"
            search={searchValue}
            limit={50}
            columns={[
                {
                    field: 'voucher_id.voucher_no',
                    header: 'Number.',
                    type: 'colorTag',
                    colorField: randomColor,
                    width: 160,
                },
                {
                    field: 'voucher_id.voucher_date',
                    header: 'Invoice Date',
                    type: 'date',
                    formatOptions: {
                        format: 'DD MMM YY',
                    },
                    width: 140,
                },
                {
                    type: 'text',
                    header: "Narration",
                    field: "voucher_id.narration",
                    width: 140,
                },
                {
                    type: 'text',
                    field: "account_id.name",
                    header: "Account",
                },
                {
                    aggregate: true,
                    type: 'currency',
                    field: "cr_amount",
                    header: "CR Amount",
                },
                {
                    aggregate: true,
                    type: 'currency',
                    field: "dr_amount",
                    header: "DR Amount",
                },
            ]}
        />
    );
};

export const VoucherTdsTab = props => {
    let { route: { params } = {} } = props;
    const { Download } = useTheme('icons');
    const { download } = useAppStateContext();
    const { onChangeFilter, searchValue, filterValues, applyFilter } = useFilter({
        params: {
            period: getCurrentMonth(),
        },
    });
    let { filter } = filterValues;
    const tabs = {
        tds: {
            label: 'Voucher TDS',
            view: (
                <VoucherTdsTable filterParams={filter} searchValue={searchValue} {...props} />
            ),
            eventSourceId: 'TDS',
            api: '/vouchertdsreport',
            addOnFilter: filter,
            actions: [
                <IconButton
                    icon={Download}
                    onPress={() => {
                        download({
                            uri: '/exportvouchertds',
                            props: {
                                addOnFilter: { ...filter },
                            },
                        });
                    }}
                />,
            ],
        },
    };

    return (
        <TabView
            {...props}
            tabs={tabs}
            params={params}
            extraFilter={filter}
            actions={[
                <GroupFilter
                    filterValues={filterValues}
                    applyFilter={applyFilter}
                    filters={[
                        {
                            type: 'date',
                            label: 'Date',
                            field: 'voucher_date',
                        },
                        {
                            type: 'multiAutoComplete',
                            label: 'Organization',
                            api: '/organizations',
                            placeholder: 'Select',
                            suggestionField: 'name',
                            valueField: 'name',
                            field: 'organization',
                        },
                        {
                            type: 'autoComplete',
                            label: 'Product',
                            api: '/products',
                            placeholder: 'Select',
                            suggestionField: 'name',
                            valueField: 'name',
                            field: 'product',
                        },
                        {
                            type: 'multiAutoComplete',
                            label: 'Account',
                            api: '/accounts',
                            suggestionField: 'name',
                            valueField: 'name',
                            field: 'account_id',
                        },
                    ]}
                />,
            ]}
        />
    );
};
